/// \file fleetDashboard.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const FleetDashboardList = lazy(() => import('../views/fleet-dashboard/list/view'));

async function fleetDashboardDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/fleet-dashboard/list/loader')).default;
  return actualLoader(args);
}

export async function fleetDashboardAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/fleet-dashboard/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path=""
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <FleetDashboardList />
        </Suspense>
      }
      loader={fleetDashboardDataLoader}
      action={fleetDashboardAction}
      />
  </Route>
);

export default routes;